import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React, { FC } from 'react';

interface CustomSvgIconProps extends SvgIconProps {
  cls1Color?: string;
  cls2Color?: string;
  svg: FC<React.SVGProps<SVGSVGElement>>
}

const CustomSvg = ({ cls1Color, cls2Color, svg, ...props }: CustomSvgIconProps) => (
    <SvgIcon
      component={svg}
      inheritViewBox={true}
      {...props}
      sx={{
        ...props.sx,
        '& .cls-1': {
          fill: cls1Color || 'currentColor',
        },
        '& .cls-2': {
          fill: cls2Color || 'currentColor',
        },
      }}
    />
);

export default CustomSvg;
